//
// Copyright (c) 2025 Comcast
//

// see https://github.com/haydenbleasel/tiptap-extension-jira/blob/main/src/extensions/text-color.ts
import { Mark, mergeAttributes } from '@tiptap/core'

const TextColor = Mark.create({
  name: 'textColor',
  addAttributes () {
    return {
      color: {
        default: null,
        parseHTML: (element) => element.style.color,
        renderHTML: (attrs) => {
          return ({ style: `color: ${attrs.color}` })
        },
      },
    }
  },
  parseHTML () {
    return [{ style: 'color' }]
  },
  renderHTML ({ HTMLAttributes }) {
    return ['span', mergeAttributes(HTMLAttributes), 0]
  },
})

export default TextColor
